import React from 'react';
import { uniqueId } from '../../utils/helpers';
import { AttributeIcon, IcnArrowR } from '../../themes/icons/attributes';
const PdpAttributes = ({ plantData, data }) => {
    const { title } = plantData;
    const getRange = (attr) => {
        const id1 = `${attr[0].attr_value.replace(/ /g, '_')}`;
        if (attr.length > 1) {
            const id2 = `${attr[attr.length - 1].attr_value.replace(/ /g, '_')}`;
            return (React.createElement("h3", null,
                React.createElement(AttributeIcon, { name: id1, className: "icn" }),
                React.createElement(IcnArrowR, { className: "divider" }),
                React.createElement(AttributeIcon, { name: id2, className: "icn" })));
        }
        return (React.createElement("h3", null,
            React.createElement(AttributeIcon, { name: id1, className: "icn" })));
    };
    const getWaterRange = (attr, index) => {
        // special function because we're isolating dry in winter/summer/dormant
        const singleAttr = [];
        const rangeAttr = [];
        const elemList = [];
        attr.attr_values.forEach((item) => {
            if (item.attr_value === 'dry in winter'
                || item.attr_value === 'dry in summer'
                || item.attr_value === 'dry when dormant') {
                singleAttr.push(item);
            }
            else {
                rangeAttr.push(item);
            }
        });
        if (rangeAttr.length > 1) {
            const id1 = `${rangeAttr[0].attr_value.replace(/ /g, '_')}`;
            const id2 = `${rangeAttr[rangeAttr.length - 1].attr_value.replace(/ /g, '_')}`;
            let valuesRange = rangeAttr[0].attr_value;
            if (rangeAttr.length > 1) {
                valuesRange += ` - ${rangeAttr[rangeAttr.length - 1].attr_value}`;
            }
            const values = React.createElement("li", null, valuesRange);
            const elem = (React.createElement("li", { key: index },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: id1, className: "icn" }),
                    React.createElement(IcnArrowR, { className: "divider" }),
                    React.createElement(AttributeIcon, { name: id2, className: "icn" })),
                React.createElement("h4", null, attr.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
            elemList.push(elem);
        }
        else if (rangeAttr.length === 1) {
            const id1 = `${rangeAttr[0].attr_value.replace(/ /g, '_')}`;
            const elem = (React.createElement("li", { key: index },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: id1, className: "icn" })),
                React.createElement("h4", null, attr.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" },
                    React.createElement("li", { key: "0" }, rangeAttr[0].attr_value))));
            elemList.push(elem);
        }
        if (singleAttr.length > 0) {
            singleAttr.forEach((item) => {
                const attrId = `${item.attr_value.replace(/ /g, '_')}`;
                const elem = (React.createElement("li", { key: item.attr_pk_value },
                    React.createElement("h3", null,
                        React.createElement(AttributeIcon, { name: attrId, className: "icn" })),
                    React.createElement("h4", null, attr.attr_name),
                    React.createElement("ul", { className: "pdp_details__list-conditions" },
                        React.createElement("li", null, item.attr_value))));
                elemList.push(elem);
            });
        }
        return elemList;
    };
    const getAttr = (attr) => {
        const attrArray = attr.map((item, index) => {
            let values = item.attr_values.map((node) => (React.createElement("li", { key: uniqueId(node.attr_value) }, node.attr_value)));
            if (item.attr_name === 'Sun Exposure') {
                const header = getRange(item.attr_values);
                let valuesRange = item.attr_values[0].attr_value;
                if (item.attr_values.length > 1) {
                    valuesRange
                        += ` - ${item.attr_values[item.attr_values.length - 1].attr_value}`;
                }
                values = React.createElement("li", null, valuesRange);
                return (React.createElement("li", { key: uniqueId(item.attr_name) },
                    header,
                    React.createElement("h4", null, item.attr_name),
                    React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
            }
            if (item.attr_name === 'Water Needs') {
                return getWaterRange(item, index);
            }
            const attrId = `attr${item.pk_value}`;
            return (React.createElement("li", { key: uniqueId(item.attr_name) },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: attrId, className: "icn" })),
                React.createElement("h4", null, item.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
        });
        return attrArray;
    };
    const gcArray = [];
    const fsArray = [];
    data.forEach((item) => {
        if (item.attr_type === 'Growing Conditions') {
            gcArray.push(item);
        }
        if (item.attr_type === 'Features'
            && item.attr_name !== 'Plant Type') {
            fsArray.push(item);
        }
    });
    const fsArrayElements = getAttr(fsArray);
    const gcArrayElements = getAttr(gcArray);
    return (React.createElement("div", { className: "pdp_details__2" },
        React.createElement("div", { className: "column" },
            React.createElement("h3", null, `How to Grow ${title}`),
            React.createElement("ul", { className: "grid pdp_details__list-attributes" }, gcArrayElements)),
        React.createElement("div", { className: "column" },
            React.createElement("h3", null, "Features"),
            React.createElement("ul", { className: "grid pdp_details__list-attributes" }, fsArrayElements))));
};
export default PdpAttributes;
